const rules = {
  orgId: [
    { required: true, message: '请选择企业主体全称', trigger: 'change' },
  ],
  purchaseQuantity: [
    { required: true,
      trigger: 'change',
      validator: (_, val, callback) => {
        if (val === '') {
          return callback(new Error('购买份数不能为空'))
        }
        if (Number(val) < 1) {
          return callback(new Error('购买份数不能小于1'))
        }
        if (Number(val) > 9999) {
          return callback(new Error('购买份数不能大于9999'))
        }
        return callback()
      },
    },
  ],
  invoiceType: [
    { required: true, message: '请选择开票类型', trigger: 'change' },
  ],
}

export { rules }
